import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Card,
  CardTitle,
  CardBody,
  CardText,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { Link } from "react-router-dom";

class Homeinsert extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(evt) {
    this.props.onFormChange([evt.target.name], evt.target.value);
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.onFormSubmit();
  }
  render() {
    return (
      <div>
        <Row className="homeInsert align-items-center justify-content-between">
          <Col md="12" lg="6" className="text-white">
            <h1 className="display-3 d-none d-md-block d-lg-block">
              Business is better online.
            </h1>
            <h1 className="display-4 d-xs-block d-sm-block d-md-none">
              Business is better online.
            </h1>
            <p className="mb-0 lead">
              Get your business a brilliant website, and show it off to a global
              market. Stormdragon Designs knows how to take your big ideas to
              the world. We can make you a custom website, built using the
              latest tools and frameworks, or host your existing website or
              project, no matter the size and scale.
            </p>
          </Col>
          <Col
            lg="5"
            className="d-none d-sm-none d-md-none d-lg-block align-items-center"
          >
            <Card>
              <CardBody>
                <CardTitle className="text-center">
                  <h2>Get a quote today:</h2>
                </CardTitle>
                <CardText>
                  <Form onSubmit={this.handleSubmit}>
                    <FormGroup row>
                      <Col>
                        <Input
                          type="text"
                          required
                          name="fname"
                          id="formFName"
                          placeholder="First Name"
                          onChange={this.handleChange}
                        />
                      </Col>
                      <Col>
                        <Input
                          type="text"
                          required
                          name="lname"
                          id="formLName"
                          placeholder="Last Name"
                          onChange={this.handleChange}
                        />
                      </Col>
                    </FormGroup>
                    <FormGroup>
                      <Input
                        type="email"
                        required
                        name="email"
                        id="formEmail"
                        placeholder="Email"
                        onChange={this.handleChange}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Input
                        type="tel"
                        required
                        name="phone"
                        id="formPhone"
                        placeholder="Phone"
                        onChange={this.handleChange}
                      />
                    </FormGroup>
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="checkbox"
                          required
                          name="consent"
                          id="formConsent"
                          onChange={this.handleChange}
                        />{" "}
                        <small>
                          I agree to the{" "}
                          <Link to="/legal/privacy-policy/">
                            privacy policy
                          </Link>{" "}
                          and to be contacted by Stormdragon Designs.
                        </small>
                      </Label>
                    </FormGroup>
                    <FormGroup className="mt-4">
                      <Button size="lg" color="primary" block>
                        Next
                      </Button>
                    </FormGroup>
                  </Form>
                </CardText>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Homeinsert;



// WEBPACK FOOTER //
// ./src/components/Homeinsert.js